import { retrieveLaunchParams } from '@tma.js/sdk-react'
import { useEffect, useRef } from 'react'
import { useNavigate } from 'react-router'
import { useAuthStore } from 'shared/store/auth'
import { isTelegram } from './platform'
import { takeStartParamRoute } from './start-param'

function readStartParam(): string | undefined {
	if (!isTelegram) return undefined
	try {
		return retrieveLaunchParams().tgWebAppStartParam
	} catch {
		return undefined
	}
}

/**
 * Navigates to the lot a `?startapp=lot_<id>` deep link points at, once per app
 * load and only after the user is authenticated (earlier and AuthGate bounces it).
 */
export function useStartParamRoute() {
	const navigate = useNavigate()
	const status = useAuthStore((s) => s.status)
	const consumed = useRef(false)

	useEffect(() => {
		if (consumed.current || status !== 'authenticated') return
		const route = takeStartParamRoute(readStartParam())
		if (!route) return
		consumed.current = true
		navigate(route)
	}, [status, navigate])
}
